import { useState, useEffect } from "react";

import { NavLink } from "react-router";
import NavigationMenu from "./NavigationMenu";
import "./Button.css";
import "./Nav.css";
import "./NavigationMenu.css";

import { localDB } from "@/database/db";
import { SignUpButton, useUser } from "@clerk/react-router";
import { clickSignupButtonDataLayer } from "@/lib/data-layer/utils";
import { AvatarWithDropdown } from "../avatar-with-dropdown";
import { cn } from "@/lib/utils";
import LoginButton from "./LoginButton";
import { MenuIcon, XIcon } from "lucide-react";
import { Button } from "../ui/button";
import {
  FlashcardFeatureIcon,
  HighlightFeatureIcon,
  QuizFeatureIcon,
  StudyFeatureIcon,
  UploadFeatureIcon,
} from "./FeatureIcons";

function GetStartedButton() {
  const authData = useUser();

  return !authData.isLoaded ? (
    <></>
  ) : !authData.isSignedIn ? (
    <SignUpButton
      mode="modal"
      forceRedirectUrl="/welcome"
      signInFallbackRedirectUrl="/welcome-back"
      signInForceRedirectUrl="/welcome-back"
      fallbackRedirectUrl="/welcome"
    >
      <Button
        variant="primary"
        size="md"
        onClick={() => {
          console.warn("clearall triggered");
          clickSignupButtonDataLayer();
          localDB.clearAll();
        }}
        className="white"
      >
        Get started
      </Button>
    </SignUpButton>
  ) : (
    <div className="flex items-center justify-center gap-1">
      <AvatarWithDropdown />
    </div>
  );
}

function Nav({ darkMode = false }: { darkMode?: boolean }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }, [isMenuOpen]);

  return (
    <nav className={cn("light-nav", darkMode ? "dark-nav" : "")}>
      <NavLink to="/home" className="Logo">
        <img
          src={darkMode ? "/assets/darkLogo.svg" : "/assets/Logo.svg"}
          alt="Logo"
        />
      </NavLink>

      {isMobile ? (
        // MOBILE VERSION: Hamburger Menu
        <>
          <button
            className="button menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? (
              <XIcon className="w-5 h-5 flex-none" />
            ) : (
              <MenuIcon className="w-5 h-5 flex-none" />
            )}
          </button>

          <ul className={`nav-links ${isMenuOpen ? "open" : "closed"}`}>
            {/* Features Section - Always Expanded */}
            <div className="dropdown-menu w-full">
              <ul>
                <p>Features</p>
                <NavLink to="/home/upload" className="nav-link">
                  <UploadFeatureIcon />
                  <div>
                    Upload
                    <p> Every file you want</p>
                  </div>
                </NavLink>
                <NavLink to="/home/highlight" className="nav-link">
                  <HighlightFeatureIcon color="violet" />
                  <div>
                    Highlight
                    <p> To understand your material</p>
                  </div>
                </NavLink>
                <NavLink to="/home/flashcard" className="nav-link">
                  <FlashcardFeatureIcon />
                  <div>
                    Generate flashcards
                    <p> Quality flashcards in seconds</p>
                  </div>
                </NavLink>
                <NavLink to="/home/study" className="nav-link">
                  <StudyFeatureIcon />
                  <div>
                    Study effectively
                    <p> With spaced repetition</p>
                  </div>
                </NavLink>
                <NavLink to="/home/quizzes" className="nav-link">
                  <QuizFeatureIcon />
                  <div>
                    Quizzes
                    <p> Test your knowledge</p>
                  </div>
                </NavLink>
              </ul>

              <p>Our story</p>
            </div>

            <NavLink
              to="/home/about"
              className="nav-link"
              onClick={() => setIsMenuOpen(false)}
            >
              About us
            </NavLink>
            <LoginButton
              variant="primary"
              size="xl"
              showAvatarWhenLoggedIn={false}
              className="white w-full"
            >
              <span>Get Started</span>
            </LoginButton>
          </ul>
        </>
      ) : (
        // DESKTOP VERSION: Regular Navbar with Dropdown
        <ul className="desktop">
          <NavigationMenu />

          <NavLink to="/home/about" className="nav-link">
            About us
          </NavLink>

          <GetStartedButton />
        </ul>
      )}
    </nav>
  );
}

export default Nav;
